<p style="font-size: 20px; text-align: center">Project/Version consumption overview</p>

<mat-table [dataSource]="data" class="mat-elevation-z8" matSort>
  <ng-container matColumnDef="project">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Project </mat-header-cell>
    <mat-cell *matCellDef="let model"> {{ model.name }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="simulations">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Simulations </mat-header-cell>
    <mat-cell *matCellDef="let model"> {{ model.versions_amount }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="cpu_hours">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Simulation credits </mat-header-cell>
    <mat-cell *matCellDef="let model">
      {{ model.credits.simulation | number : '' : 'de' }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="support">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Support credits </mat-header-cell>
    <mat-cell *matCellDef="let model">
      {{ model.credits.support | number : '' : 'de' }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="credits">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Total credits </mat-header-cell>
    <mat-cell *matCellDef="let model">
      {{ model.credits.simulation + model.credits.support | number : '' : 'de' }}
      <mat-icon style="position: absolute; right: 15px">expand_more</mat-icon>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="materialColumns"></mat-header-row>
  <mat-row
    #dirs
    (click)="expanded(row.uuid)"
    *matRowDef="let row; let i = index; columns: materialColumns"
    [ngClass]="{ 'transparent-row': row.expanded === false }"
    matRipple
    class="element-row"
    [cdkDetailRowColor]="dataTableSource"
    [cdkDetailRowIndex]="i"
    [cdkDetailRow]="row"
    [cdkDetailRowTpl]="tpl">
  </mat-row>
</mat-table>

<ng-template #tpl let-overviewList>
  <div class="mat-row detail-row" [@detailExpand] style="overflow: hidden">
    <table aria-label="creditsTable" class="table table-bordered" style="text-align: center">
      <thead>
        <tr>
          <th>Simulation</th>
          <th>Date</th>
          <th>Credits</th>
        </tr>
      </thead>

      <tbody style="text-align: center">
        <tr *ngFor="let curve of overviewList.versions">
          <td>{{ curve.title }}</td>
          <td>{{ curve.created_at }}</td>
          <td>{{ curve.credits | number : '' : 'de' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
